import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        path: "/",
        component: () => import("@/views/koc/index.vue"),
    },
    {
        path: "/koc",
        component: () => import("@/views/koc/index.vue"),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Tea 上报路由PV
router.afterEach((to, from) => {
    try {
        window.collectEvent("official_page_view", {
            url: window.location.href,
            host: window.location.hostname,
            path: to.path,
            title: to.meta?.title || document.title,
            time: Math.floor(Date.now() / 1000),
            app_id: 6689,
            user_unique_id: window.web_id,
        });
        console.log("Tea 上报路由PV 成功");
    } catch (error) {
        console.error("Tea 上报路由PV 失败:", error);
    }
})
export default router;
